import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'
import { animated } from 'react-spring'

import { useHooks } from './methods'

import Container from './style'

interface Props {
  children: ReactNode | string
  style?: CSSProperties
  className?: string
  id?: string
}

function Widget({ id, children, className, style }: Props): ReactElement {
  const { bgSpring, setHover, resetHover } = useHooks()
  return (
    <Container
      id={id}
      className={className}
      style={style}
      onMouseEnter={setHover}
      onMouseLeave={resetHover}
    >
      <figure>
        <animated.div
          style={bgSpring}
          className="widget-background"
        ></animated.div>
      </figure>
      <article>{children}</article>
    </Container>
  )
}

Widget.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

Widget.defaultProps = {
  className: '',
}

export default memo(Widget)
